import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaCommentDots } from "react-icons/fa";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { successToast, errorToast } from "../../Utils/toast";
import { openModal } from "../../redux/features/modalSlice";
import { STATUS_OPTIONS } from "../../Constant/leadConstent";
import Pagination from "../../common/Pagination";
import {
  AssignedLeadList,
  updateLeadStatus,
  deleteLead,
} from "../../redux/services/leadServices/Lead.Services";

function NewAssignLead() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const role = localStorage.getItem("role");
  const isAdmin = role === "admin";
  const [activeFilter, setActiveFilter] = useState("all");
  const [page, setPage] = useState(1);

  const [leadData, setLeadData] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const [totalPages, setTotalPages] = useState(1);
  const [totalLeads, setTotalLeads] = useState(0);

  const [limit, setLimit] = useState(100);
  const [counts, setCounts] = useState({
    all: 0,
  });
  // ================= FETCH LEADS =================
  const fetchLeads = async (pageNo = 1, isInitialLoad = false) => {
    try {
      const payload = {
        page: pageNo,
        per_page: limit,
      };
      if (isInitialLoad) {
        setInitialLoading(true);
      } else {
        setTableLoading(true);
      }
      const response = await AssignedLeadList(payload);
      const leads = response?.data?.data || response?.data || [];

      setPage(response?.current_page || pageNo);
      setTotalPages(response?.last_page || 1);
      setTotalLeads(response?.total || leads.length);

      setFilteredLeads(leads);

      setCounts({
        all: response?.total || leads.length,
      });
    } catch (error) {
      console.log(error);
      errorToast("Failed to fetch leads");
    } finally {
      setInitialLoading(false);
      setTableLoading(false);
    }
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    try {
      const res = await deleteLead({ id });

      successToast(res?.message || "Deleted");

      const updated = leadData.filter((item) => item.id !== id);

      setLeadData(updated);
      setFilteredLeads(updated);
    } catch (error) {
      errorToast(error?.message || "Delete failed");
    }
  };

  // ================= STATUS UPDATE =================
  const handleStatusUpdate = async (data) => {
    try {
      await updateLeadStatus(data);

      Swal.fire({
        icon: "success",
        title: "Status Updated",
        text: "Lead status updated successfully!",
        timer: 1500,
        showConfirmButton: false,
      });

      fetchLeads(page);
    } catch (error) {
      console.log(error);
      errorToast("Status update failed");
    }
  };

  // ================= USE EFFECT =================
  useEffect(() => {
    fetchLeads(1, true);
  }, []);
  const tabs = [
    {
      label: `All Leads (${counts.all})`,
      className: "btn-all",
      value: "all",
    },
  ];
  const handlePageChange = (newPage) => {
    if (
      newPage >= 1 &&
      newPage <= totalPages &&
      !tableLoading
    ) {
      setPage(newPage);
      fetchLeads(newPage);
    }
  };
  const handleFilterClick = (filter) => {
    setActiveFilter(filter);

    if (filter === "all") {
      setFilteredLeads(leadData);
    }
  };
  // ================= LOADING =================
  if (initialLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }
  return (
    <div>
      {/* HEADER */}
      <div className="d-md-flex d-block align-items-center justify-content-between  page-header-breadcrumb">
     
            <div className="d-flex justify-content-between align-items-center w-100">
   <div className="ms-md-1 mb-2 mb-md-0">
          <h4 className="fw-semibold mb-0">All Lead List</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active">All Leads</li>
          </ol>
        </div>
          <div>
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`lead-btn btn-all ${tab.className} ${activeFilter === tab.value ? "active" : ""
                  }`}
                onClick={() => handleFilterClick(tab.value)}
              >
                {tab.label}
              </button>
            ))}
    

        </div>
            </div>
     
     
      </div>

      {totalLeads > limit && (
        <div className="d-flex justify-content-between align-items-center flex-wrap">


          {/* <div className="d-flex align-items-center">
                        <label className="mb-0">Show</label>
                        <select
                            className="form-select form-select-sm"
                            value={limit}
                            onChange={(e) => {
                                const newLimit = Number(e.target.value);
                                setLimit(newLimit);
                                setPage(1);
                                fetchLeads(1);
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div> */}

          <div className="col-12 d-flex justify-content-end">

            <Pagination
              page={page}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>


        </div>
      )}      <div className="st-wrapper-card">
        <div className="st-table-responsive">
          <table className="table st-custom-table align-middle">
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>Lead ID</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Source</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {tableLoading ? (
                <tr>
                  <td colSpan="6" className="text-center py-5">
                    <div className="spinner-border text-primary"></div>
                  </td>
                </tr>
              ) : filteredLeads?.length > 0 ? (
                filteredLeads?.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(page - 1) * limit + index + 1}</td>
                    <td>{item.lead_id}</td>
                    <td className="fw-semibold">{item.name}</td>
                    <td>{item.mobile}</td>
                    <td>
                      <span
                        className={`source-badge ${item.source === "Website"
                          ? "website"
                          : item.source === "Facebook"
                            ? "facebook"
                            : item.source === "Justdial"
                              ? "instagram"
                              : item.source === "IndiaMART"
                                ? "indiamart"
                                : ""
                          }`}
                      >
                        {item.source}
                      </span>
                    </td>

                    <td className="text-center">
                      <div className="d-flex align-items-center justify-content-center gap-1">

                        <button
                          className="st-action-btn st-view-btn"
                          onClick={() =>
                            navigate(`/view-lead/${item.id}`)
                          }
                        >
                          <FaEye />
                        </button>

                        {/* STATUS UPDATE
                    <button
                      className="st-action-btn st-edit-btn"
                      onClick={() =>
                        dispatch(
                          openModal({
                            type: "update-status",
                            title: "Update Lead Status",
                            data: {
                              id: item.id,
                              status: item.status,
                              statusOptions: STATUS_OPTIONS,
                              role,
                              onSubmit: handleStatusUpdate,
                              onSuccess: () => fetchLeads(page),
                            },
                          })
                        )
                      }
                    >
                      <FaEdit />
                    </button> */}

                        {/* REMARK */}
                        <button
                          className="st-action-btn st-view-btn"
                          onClick={() =>
                            navigate(`/remark-history/${item.id}`)
                          }
                        >
                          <FaCommentDots />
                        </button>
                      </div>
                      {/* VIEW */}

                    </td>
                  </tr>

                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    No leads found
                  </td>
                </tr>
              )}

            </tbody>
          </table>

          {/* PAGINATION */}
          {totalLeads > limit && (
            <div className='d-flex justify-content-end'>
              <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NewAssignLead;